import type { RevitDataType } from './types';

export function normalizeRevitDataType(dataType: unknown): RevitDataType {
  const normalized = typeof dataType === 'string' ? dataType.trim().toLowerCase() : '';
  if (['number', 'integer', 'double'].includes(normalized)) return 'number';
  if (['boolean', 'yesno', 'yes/no'].includes(normalized)) return 'boolean';
  if (['length', 'area', 'volume', 'angle'].includes(normalized)) {
    return normalized as RevitDataType;
  }
  if (normalized === 'multilinetext' || normalized === 'multiline text') {
    return 'multilineText';
  }
  if (['pipe_mass', 'pipemass', 'pipe mass'].includes(normalized)) return 'pipeMass';
  if (normalized === 'elementid' || normalized === 'element id') return 'elementId';
  return 'string';
}
